import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { PageLayout } from '../../ui';
import ApplicationList from '../../components/applications/ApplicationList/ApplicationList';
import ApplicationForm from '../../components/applications/ApplicationForm/ApplicationForm';
import UploadDocumentModal from '../../components/documents/UploadDocumentModal';
import { Application } from '../../types';

const ApplicationsPage: React.FC = () => {
  const navigate = useNavigate();

  const [isCreateFormVisible, setIsCreateFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState<Application | null>(null);
  const [applicationUpdated, setApplicationUpdated] = useState(0);

  const handleCreateClick = () => {
    setIsCreateFormVisible(true);
  };

  const handleViewClick = (application: Application) => {
    navigate(`/applications/${application.id}`);
  };

  const [primaryDocsModalApplication, setPrimaryDocsModalApplication] = useState<Application | null>(null);

  const handleUploadClick = (application: Application) => {
    setPrimaryDocsModalApplication(application);
  };

  const handleEditClick = (application: Application) => {
    setSelectedApplication(application);
    setIsEditFormVisible(true);
  };

  const handleFormSuccess = (_application: Application) => {
    setIsCreateFormVisible(false);
    setIsEditFormVisible(false);
    setSelectedApplication(null);
    setApplicationUpdated((prev) => prev + 1);
  };

  const handleFormCancel = () => {
    setIsCreateFormVisible(false);
    setIsEditFormVisible(false);
    setSelectedApplication(null);
  };

  return (
    <PageLayout
      title="Заявки"
      subtitle="Управление заявками на перевозку грузов"
      actions={
        <Button type="primary" icon={<PlusOutlined />} onClick={handleCreateClick}>
          Создать заявку
        </Button>
      }
    >
      <ApplicationList
        onCreateClick={handleCreateClick}
        onViewClick={handleViewClick}
        onEditClick={handleEditClick}
        onUploadClick={handleUploadClick}
        applicationUpdatedTrigger={applicationUpdated}
      />

      <ApplicationForm
        key="create"
        visible={isCreateFormVisible}
        onCancel={handleFormCancel}
        onSuccess={handleFormSuccess}
      />

      <UploadDocumentModal
        visible={primaryDocsModalApplication != null}
        onCancel={() => setPrimaryDocsModalApplication(null)}
        onSuccess={() => {
          setApplicationUpdated((prev) => prev + 1);
          setPrimaryDocsModalApplication(null);
        }}
        application={primaryDocsModalApplication || undefined}
        isPrimaryDocs={true}
      />

      {selectedApplication && (
        <ApplicationForm
          key={selectedApplication.id}
          visible={isEditFormVisible}
          application={selectedApplication}
          applicationId={selectedApplication.id}
          onCancel={handleFormCancel}
          onSuccess={handleFormSuccess}
        />
      )}
    </PageLayout>
  );
};

export default ApplicationsPage;
